import Logo from "./Logo";
import { useI18n } from "@/i18n";

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Footer() {
  const { t } = useI18n();

  const COLUMNS = [
    {
      title: t("footer.cols.company"),
      links: [
        { label: t("footer.links.about"), id: "about" },
        { label: t("footer.links.products"), id: "products" },
        { label: t("footer.links.brands"), id: "brands" },
        { label: t("footer.links.why"), id: "why" },
      ],
    },
    {
      title: t("footer.cols.trading"),
      links: [
        { label: t("footer.links.mobile_phones"), id: "products" },
        { label: t("footer.links.smartphones"), id: "products" },
        { label: t("footer.links.accessories"), id: "products" },
        { label: t("footer.links.bulk_orders"), id: "products" },
      ],
    },
    {
      title: t("footer.cols.contact"),
      links: [
        { label: t("footer.links.request_quote"), id: "contact" },
        { label: t("footer.links.whatsapp"), id: "contact", external: "https://wa.me/971542005570" },
        { label: t("footer.links.email"), id: "contact", external: "mailto:info@primezone.ae" },
        { label: t("footer.links.location"), id: "contact" },
      ],
    },
  ];

  return (
    <footer data-testid="site-footer" className="relative pt-20 pb-10 mt-10 border-t border-white/10 bg-[#050507]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="relative inline-flex items-center justify-center w-11 h-11 rounded-xl glass">
                <Logo size={28} />
              </span>
              <span className="font-display text-[16px] font-semibold text-white">
                {t("brand.name_prefix")}
                <span className="text-[#A8A8B3] font-medium"> {t("brand.name_suffix")}</span>
              </span>
            </div>
            <p className="mt-5 text-[14px] text-[#A8A8B3] max-w-md leading-relaxed">
              {t("footer.tagline")}
              <br />
              {t("footer.address_l1")}
              <br />
              {t("footer.address_l2")}
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <div className="text-[11px] tracking-[0.22em] uppercase text-[#8B6DFF] mb-4">{col.title}</div>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.external ? (
                        <a
                          href={l.external}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[14px] text-[#D5D6DC] hover:text-white transition-colors"
                        >
                          {l.label}
                        </a>
                      ) : (
                        <button
                          onClick={() => scrollTo(l.id)}
                          className="text-[14px] text-[#D5D6DC] hover:text-white transition-colors text-start"
                        >
                          {l.label}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="divider-glow my-10" />

        <div className="flex flex-col md:flex-row gap-3 items-center justify-between text-[12.5px] text-[#6F7280]">
          <div>{t("footer.copyright")}</div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7A5CFF] shadow-[0_0_10px_rgba(122,92,255,0.9)]" />
            {t("footer.built_for")}
          </div>
        </div>
      </div>
    </footer>
  );
}
